'use strict';

var React = require('react'),
    Collection = require('./Collection'),
    Icon = require('../atoms/Icon'),
    Loader = require('../atoms/Loader'),
    Link = require('../atoms/Link'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React,
    { pick } = require('underscore');

require('./Group.less');

var Group = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    color: PropTypes.oneOf(['dark', 'light']).isRequired,
    title: PropTypes.string,
    isExpectingPage: PropTypes.bool.isRequired,
    isLastPage: PropTypes.bool.isRequired,
    isInvalidated: PropTypes.bool,
    loadNextPage: PropTypes.func,
    type: PropTypes.any.isRequired,
    mode: PropTypes.any,
    columns: PropTypes.number,
    keys: PropTypes.array,
    items: PropTypes.array.isRequired,
    itemProps: PropTypes.object,
    getItemProps: PropTypes.func,
    defaultPage: PropTypes.number,
    onPageChange: PropTypes.func,
    perFirstPage: PropTypes.number,
    perPage: PropTypes.number,
    showInvalidationFeedback: PropTypes.bool
  },

  getDefaultProps() {
    return {
      isExpectingPage: false,
      showInvalidationFeedback: false,
      isLastPage: true,
      defaultPage: 0,
      perPage: 24,
      perFirstPage: 24,
      color: 'dark'
    };
  },

  getInitialState() {
    return {
      page: this.props.defaultPage
    };
  },

  getCSSModifiers() {
    return [this.props.color];
  },

  hasNextPage() {
    return this.props.loadNextPage && !this.props.isLastPage;
  },

  getMaxItemCount() {
    var { perPage, perFirstPage } = this.props,
        { page } = this.state;

    if (perFirstPage < perPage) {
      return page === 0 ? perFirstPage : page * perPage;
    } else {
      return (page + 1) * perPage;
    }
  },

  loadItemsToSatisfyPage() {
    if (this.props.isExpectingPage || !this.hasNextPage()) {
      return;
    }

    if (this.getMaxItemCount() > this.props.items.length) {
      this.props.loadNextPage();
      return true;
    }
  },

  componentDidUpdate(prevProps, prevState) {
    if (this.state.page !== prevState.page ||
        this.props.items.length > prevProps.items.length) {

      this.loadItemsToSatisfyPage();
    }
  },

  render() {
    var { title, isExpectingPage, isInvalidated, showInvalidationFeedback, keys: allKeys, items: allItems, color } = this.props,
        maxCount = this.getMaxItemCount(),
        visibleItems = allItems.slice(0, maxCount),
        visibleKeys = allKeys ? allKeys.slice(0, maxCount) : null,
        isEmpty = visibleItems.length === 0,
        mayHaveMore = this.hasNextPage() || maxCount < allItems.length,
        isExpectingFirstPage = isExpectingPage && isEmpty,
        isExpectingNextPage = isExpectingPage && !isEmpty && !isInvalidated,
        isExpectingInvalidatedFirstPage = isInvalidated && !isExpectingFirstPage && !isExpectingNextPage,
        showLoadMore = !isEmpty && mayHaveMore;

    return (
      <div className={this.getClassName()}>
        {title &&
          <div className='Group-title'>
            {title}
          </div>
        }

        {showInvalidationFeedback && isExpectingInvalidatedFirstPage &&
          <div className='Group-header'>
            <Loader color={color} />
          </div>
        }

        <div className='Group-body'>
          {isExpectingFirstPage &&
            <Loader color={color}
                    absoluteCenter />
          }

          {!isExpectingFirstPage &&
            <Collection items={visibleItems}
                        keys={visibleKeys}
                        {...pick(this.props, 'type', 'mode', 'columns', 'context', 'itemProps', 'getItemProps')}>
              {this.props.children}
            </Collection>
          }
        </div>

        {showLoadMore &&
          <div className='Group-footer'>
            {isExpectingNextPage ?
              <Loader color={color} />
            :
              <Link className='Group-loadMore'
                    underline='never'
                    onClick={this.handleLoadMoreClick}
                    smallCaps>
                Show More
                <Icon name='arrowDown'
                      mode='stroke'
                      size='small' />
              </Link>
            }
          </div>
        }
      </div>
    );
  },

  handleLoadMoreClick() {
    if (this.props.isExpectingPage) {
      return;
    }

    if (this.loadItemsToSatisfyPage()) {
      return;
    }

    this.setState({
      page: this.state.page + 1
    }, this.pageDidChange);
  },

  pageDidChange() {
    if (this.props.onPageChange) {
      this.props.onPageChange(this.state.page);
    }
  }
});

module.exports = Group;



/** WEBPACK FOOTER **
 ** ./organisms/Group.jsx
 **/